module.exports = __webpack_public_path__ + "img/es.2755b022.svg";